import { Image, ImageProps } from '@jfs/ui-new'
import { useCallback, useEffect, useState } from 'react'
import { PAYMENT_MODE_SUBTYPES } from '../../utils/constants'
export const LogoImage = ({ imgUrl, type }: { imgUrl: string; type: number }) => {
  const [imageUrl, setImageUrl] = useState(imgUrl)
  useEffect(() => {
    setImageUrl(imgUrl)
  }, [imgUrl])
  const onError = useCallback(() => {
    setImageUrl('')
  }, [])
  if (imageUrl) {
    return <Image {...styles.imageView} source={imageUrl} onError={onError} />
  }
  return (
    <Image
      {...styles.imageView}
      resizeMode="contain"
      source={
        type === PAYMENT_MODE_SUBTYPES.NB
          ? require('../../assets/images/bank.png')
          : require('../../assets/images/wallet.png')
      }
    />
  )
}

const styles = {
  imageView: {
    height: 32,
    width: 32,
  } as ImageProps,
}
